"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[587],{

/***/ 2908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ FallBackImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const FallBackImage = (param)=>{
    let { src , alt , ...rest } = param;
    const [imgSrc, setImgSrc] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(src);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setImgSrc(src);
    }, [
        src
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        ...rest,
        alt: alt,
        src: imgSrc ? imgSrc : "/img/no-image.jpeg",
        onError: ()=>{
            setImgSrc("/img/no-image.jpeg");
        }
    });
};


/***/ }),

/***/ 5587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HomeLastOffers; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7333);
/* harmony import */ var _default_fallback_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2908);



function HomeLastOffers(param) {
    let { ads  } = param;
    var _price, _mileage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "latest-collection pb-120",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row align-items-center justify-content-between",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-lg-12",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "at-section-title text-center text-lg-start",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "at-subtitle position-relative lead text-primary",
                                        children: "\xdaltimas Ofertas"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "h3 mt-2 mb-0",
                                        children: "Confira as nossas \xfaltimas ofertas!"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "filter-items-wrapper mt-5",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row g-4 justify-content-center filter-grid",
                            children: ads.items.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-6 col-xxs-12",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "filter-card-item position-relative overflow-hidden rounded bg-white",
                                        style: {
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>{
                                            window.location = "anuncio/".concat(item.category, "/").concat("".concat(item.brand.split(" ").join("-").toLowerCase(), "-").concat(item.model.split(" ").join("-").toLowerCase()), "/").concat(item.yearModel, "/").concat(item.id);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "feature-thumb position-relative overflow-hidden",
                                                style: {
                                                    position: "relative",
                                                    width: "100%",
                                                    maxWidth: "430px",
                                                    aspectRatio: "70/55"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "anuncio/".concat(item.category, "/").concat("".concat(item.brand.split(" ").join("-").toLowerCase(), "-").concat(item.model.split(" ").join("-").toLowerCase()), "/").concat(item.yearModel, "/").concat(item.id),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_default_fallback_image__WEBPACK_IMPORTED_MODULE_2__/* .FallBackImage */ .A, {
                                                        className: "img-card-fluid",
                                                        priority: true,
                                                        width: 430,
                                                        height: 276,
                                                        alt: "".concat(item.brand, " ").concat(item.model),
                                                        src: item.mainPhoto ? item.mainPhoto : "/img/no-image.jpeg"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "filter-card-content",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "price-btn text-end position-relative",
                                                        children: [
                                                            item.promotionalPrice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                className: "price",
                                                                children: item.price ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_1__/* .NumericFormat */ .h3, {
                                                                    className: "small-btn-meta",
                                                                    style: {
                                                                        color: "white",
                                                                        fontSize: "14px",
                                                                        textDecoration: "line-through"
                                                                    },
                                                                    value: (_price = item.price) !== null && _price !== void 0 ? _price : 0,
                                                                    displayType: "text",
                                                                    thousandSeparator: ".",
                                                                    decimalSeparator: ",",
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true,
                                                                    prefix: "De R$ "
                                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "small-btn-meta",
                                                                    children: "Consulte-nos"
                                                                })
                                                            }) : null,
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                className: "price",
                                                                children: item.price ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_1__/* .NumericFormat */ .h3, {
                                                                    className: "small-btn-meta",
                                                                    style: {
                                                                        fontSize: "16px"
                                                                    },
                                                                    value: item.promotionalPrice ? item.promotionalPrice : item.price,
                                                                    displayType: "text",
                                                                    thousandSeparator: ".",
                                                                    decimalSeparator: ",",
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true,
                                                                    prefix: "".concat(item.promotionalPrice ? "Por R$ " : "R$ ")
                                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "small-btn-meta",
                                                                    children: "Consulte-nos"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "anuncio/".concat(item.category, "/").concat("".concat(item.brand.split(" ").join("-").toLowerCase(), "-").concat(item.model.split(" ").join("-").toLowerCase()), "/").concat(item.yearModel, "/").concat(item.id),
                                                        className: "mt-2 d-block",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "h5",
                                                            children: "".concat(item.brand, " ").concat(item.model)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "meta-content",
                                                        style: {
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            display: "inline-block",
                                                            width: "100%"
                                                        },
                                                        children: item.version
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                                        className: "spacer mt-3 mb-3"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "card-feature-box d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "icon-box d-flex align-items-center",
                                                                title: item.transmission,
                                                                style: {
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    display: "inline-block",
                                                                    width: "100%"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "me-2",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "flaticon-steering-wheel"
                                                                        })
                                                                    }),
                                                                    item.transmission
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "icon-box d-flex align-items-center",
                                                                title: item.fuel,
                                                                style: {
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    display: "inline-block",
                                                                    width: "100%"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "me-2",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "flaticon-petrol"
                                                                        })
                                                                    }),
                                                                    item.fuel
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "card-feature-box d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "icon-box d-flex align-items-center",
                                                                title: item.transmission,
                                                                style: {
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    display: "inline-block",
                                                                    width: "100%"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "me-2",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "flaticon-calendar"
                                                                        })
                                                                    }),
                                                                    item.yearModel
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "icon-box d-flex align-items-center",
                                                                title: item.fuel,
                                                                style: {
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    display: "inline-block",
                                                                    width: "100%"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "me-2",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "fa fa-gauge"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_1__/* .NumericFormat */ .h3, {
                                                                        value: (_mileage = item.mileage) !== null && _mileage !== void 0 ? _mileage : 0,
                                                                        displayType: "text",
                                                                        thousandSeparator: ".",
                                                                        decimalSeparator: ","
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, index))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-center mt-5",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: "/estoque",
                            className: "at-explore-btn color-secondary",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "me-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                        width: "39",
                                        height: "26",
                                        viewBox: "0 0 39 26",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "svg",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M32.7143 7.85706L37.5142 12.9999M37.5142 12.9999L32.7143 18.1428M37.5142 12.9999H18.1428",
                                                strokeWidth: "1.71429",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                cx: "13",
                                                cy: "13",
                                                r: "12",
                                                strokeWidth: "1.71429"
                                            })
                                        ]
                                    })
                                }),
                                "ver mais ofertas"
                            ]
                        })
                    })
                ]
            })
        })
    });
}


/***/ })

}]);